import {
  HIGHLIGHT_ADD,
  ARTICLE_ADD,
  TAGS_UPDATE_ON_ENTRY,
  ENTRIES_FETCH_SUCCESS,
  HIGHLIGHTS_FETCH_SUCCESS,
  ARTICLES_FETCH_SUCCESS,
  TAGS_FETCH_SUCCESS,
  LISTENER_ADD,
  UNLISTEN
} from './actionTypes';

import {
  TAGS
} from './firebaseNaming';

import { IS_NOT_AUTHENTICATED } from 'services/auth/actionTypes';
import { makeDebugger } from 'lib';

const debug = makeDebugger('data/reducer');

const INITIAL_STATE = {
  highlights: {},
  articles: {},
  entries: {},
  tagDateMap: {},
  tags: [],
  listeners: []
}

const getNewEntries = (removed, added, updated) => (oldEntries) => {
  const entriesCopy = { ...oldEntries };
  for (let e of updated) {
    const entry = entriesCopy[e.id]
    entriesCopy[e.id] = { ...entry, ...e };
  }
  for (let e of added) entriesCopy[e.id] = e;
  for (let id of removed) delete entriesCopy[id];
  return entriesCopy;
}

export const reducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case TAGS_FETCH_SUCCESS: //TODO: update to handle docChanges, if there are a lot of tags
      return { ...state, tags: action.payload.tags, tagDateMap: action.payload.tagDateMap}
    case ENTRIES_FETCH_SUCCESS:
      const { updated, added, removed } = action.payload;
      const entries = getNewEntries(removed, added, updated)(state.entries);
      return { ...state, entries }
    case TAGS_UPDATE_ON_ENTRY:
      const entriesCopy = { ...state.entries };
      const id = action.payload.id;
      const entry = entriesCopy[id];
      if (!entry) return state; // TODO: If race condition, and tags get updated while entry is deleted or in the middle of adding
      entry[TAGS] = action.payload.tags;
      debug('tags updated on entry')
      debug('recreated entry: ', entry)
      entriesCopy[id] = entry;
      debug(id, entriesCopy, entriesCopy[id])
      return { ...state,  entries: entriesCopy };
    case LISTENER_ADD:
      return { ...state, listeners: [ ...state.listeners, action.payload]}
    case UNLISTEN:
    case IS_NOT_AUTHENTICATED:
      for (let unsubscribe of state.listeners) unsubscribe();
      return INITIAL_STATE;
    case HIGHLIGHTS_FETCH_SUCCESS:
      return { ...state, highlights: action.payload}
    case ARTICLES_FETCH_SUCCESS:
      return { ...state, articles: action.payload}
    case HIGHLIGHT_ADD:
      const newHighlights = { ...state.highlights };
      const hid = action.payload.id;
      const oldH = state.highlights[hid];
      if (!oldH) return state;
      const newH = { ...oldH, ...action.payload}
      newHighlights[hid] = newH;
      return { ...state,  highlights: newHighlights };
    case ARTICLE_ADD:
      const newArticles = { ...state.articles };
      const aid = action.payload.id;
      const oldA = state.articles[aid];
      if (!oldA) return state;
      const newA = { ...oldA, ...action.payload}
      newArticles[aid] = newA;
      return { ...state,  articles: newArticles };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/data/reducer.js